"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_LOADING_STATE = exports.SET_API_STATUS = exports.SET_SEARCH_RESULT = exports.FETCH_ADD = exports.FETCH_SEARCH = exports.slice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const reduxUtils_1 = require("@utils/reduxUtils");
const data_1 = require("./data");
exports.slice = (0, toolkit_1.createSlice)({
    name: 'df0001',
    initialState: data_1.initialState,
    reducers: {
        FETCH_SEARCH: (0, reduxUtils_1.sendPayloadObject)(reduxUtils_1.ReduxResponseColumns.PAYLOAD),
        FETCH_ADD: (0, reduxUtils_1.sendPayloadObject)(reduxUtils_1.ReduxResponseColumns.PAYLOAD),
        SET_SEARCH_RESULT: (0, reduxUtils_1.sendPayloadObject)('searchResult'),
        SET_API_STATUS: (0, reduxUtils_1.sendPayloadObject)('apiStatus'),
        SET_LOADING_STATE: (0, reduxUtils_1.sendPayloadObject)('loadingState')
    }
});
_a = exports.slice.actions, exports.FETCH_SEARCH = _a.FETCH_SEARCH, exports.FETCH_ADD = _a.FETCH_ADD, exports.SET_SEARCH_RESULT = _a.SET_SEARCH_RESULT, exports.SET_API_STATUS = _a.SET_API_STATUS, exports.SET_LOADING_STATE = _a.SET_LOADING_STATE;
exports.default = exports.slice.reducer;
